const API_ROOT = '/public';

// eslint-disable-next-line import/prefer-default-export
export const ApiRoutes = {
  DOCUMENTS: `${API_ROOT}/documents`,
  RECORDS: `${API_ROOT}/records`,
  MIGRATED_RECORDS: `${API_ROOT}/records/migrated`,
  LEGAL_FIELDS: `${API_ROOT}/legal_fields`,
  INTROSPECTION: `${API_ROOT}/me`,
  BRANDING_TOOLS: `${API_ROOT}/branding`,

  SEARCH: {
    DOCUMENTS: `${API_ROOT}/documents/search`,
    RECORDS: `${API_ROOT}/records/search`,
    MIGRATED_RECORDS: `${API_ROOT}/records/migrated/search`,
  },

  DOCUMENT: {
    base: (id: string) => `${API_ROOT}/documents/${id}`,
    questionnaire: (id: string) => `${API_ROOT}/documents/${id}/questionnaire`,
    representation: (id: string) => `${API_ROOT}/documents/${id}/representation`,
    preview: (id: string) => `${API_ROOT}/documents/${id}/preview`,
    download: (id: string) => `${API_ROOT}/documents/${id}/download`,
  },

  RECORD: {
    base: (id: string) => `${API_ROOT}/records/${id}`,
    representation: (id: string) => `${API_ROOT}/records/${id}/representation`,
    preview: (id: string) => `${API_ROOT}/records/${id}/preview`,
    download: (id: string) => `${API_ROOT}/records/${id}/download`,
  },

  MIGRATED_RECORD: {
    base: (id: string) => `${API_ROOT}/records/migrated/${id}`,
    preview: (id: string) => `${API_ROOT}/records/migrated/${id}/preview`,
    download: (id: string) => `${API_ROOT}/records/migrated/${id}/download`,
  },
};
